import { CENTRAL_DOACOES_PERMISSIONS } from "constants/index";
import React, { Component } from "react";
import "react-toastify/dist/ReactToastify.css";
import Title from "../../../components/Title/title.component";
import centralDoacaoService from "../../../services/centralDoacaoService";
import ListagemContainer, {
	PesquisaAvancadaContext
} from "../../comum/containers/listagem.container";
import CadastrarModal from "../cadastraDoacoes/cadastraDoacoes.modal";
import PesquisaAvancadaDoacoes from "./pesquisaAvancadaDoacoes";

export default class ListaDoacoes extends Component {
	columns = [
		{
			id: 0,
			title: "Código",
			property: "id",
			order: "id"
		},
		{
			id: 1,
			title: "Item",
			property: "unidadeDeExibicao",
			order: "nome"
		},
		{
			id: 2,
			title: "Quantidade em estoque",
			property: "quantidadeEstoque"
		}
	];

	actions = [
		{
			id: 0,
			name: "Gerenciar item",
			icon: "fas fa-cogs",
			action: item => this.handleGerenciar(item)
		}
	];

	state = {
		filtro: {
			nome: "",
			codigo: undefined,
			tiposDeItemSelecionados: [],
			unidadesSelecionadas: [],
			idUnidades: [],
			idTiposDeItemSelecionados: [],
			simplificado: true,
			ordem: ""
		},
		pesquisaAvancada: false,
		tiposDeItem: [],
		unidades: [],
		orderIcon: {
			nome: "",
			icon: undefined
		},
		inititalOrderIcon: {
			colunaTable: "id",
			iconOrderDirection: "fas fa-arrow-down"
		}
	};

	constructor(props) {
		super(props);
		this.child = React.createRef();
	}

	async componentDidMount() {
		const allTiposDeItem = await centralDoacaoService.findAllTipoItemDoacao();
		const allUnidades = await centralDoacaoService.findAllUnidadeMedida();
		this.setState({
			unidades: [...allUnidades.data.dados],
			tiposDeItem: [...allTiposDeItem.data.dados]
		});
	}

	handleGerenciar = item => {
		const { history } = this.props;
		history.push(`/centralDoacoes/gerenciadoacao/${item.id}`);
	};

	/* Filtro */
	handlePesquisaSimplificada = () => {
		const prevState = this.state;
		prevState.filtro.simplificado = true;
		prevState.pesquisaAvancada = false;
		prevState.orderIcon = { icon: undefined, nomeColuna: "" };
		this.setState(prevState);
		this.child.current.limpaCampoPesquisaSimplificada();
	};

	ordenar = ordem => {
		const direcaoOrdemFiltro = this.child.current.handleSearchByOrder(
			ordem,
			true
		);

		if (direcaoOrdemFiltro === "DESC") {
			this.setState({
				orderIcon: { icon: "fas fa-arrow-down", nomeColuna: ordem }
			});
		} else {
			this.setState({
				orderIcon: { icon: "fas fa-arrow-up", nomeColuna: ordem }
			});
		}
	};

	handlePesquisaAvancada = () => {
		const prevState = this.state;
		prevState.filtro.simplificado = false;
		prevState.pesquisaAvancada = true;
		prevState.orderIcon = { icon: undefined, nomeColuna: "" };
		this.setState(prevState);
	};

	resetIconOrder = () => {
		this.setState({ orderIcon: { icon: undefined, nomeColuna: "" } });
	};

	handleReload() {
		this.child.current.initialize();
	}

	render() {
		const {
			unidades,
			tiposDeItem,
			pesquisaAvancada,
			filtro,
			orderIcon,
			inititalOrderIcon
		} = this.state;
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-md-12">
						<Title>Estoque</Title>
					</div>
				</div>
				<ListagemContainer
					ref={this.child}
					columns={this.columns}
					actions={this.actions}
					listaTitle="Listagem de estoque"
					pesquisaTitle={null}
					servicePaginacao={centralDoacaoService.findAll}
					serviceSearch={centralDoacaoService.findAll}
					serviceCadastrar={centralDoacaoService.cadastraDoacao}
					acoesSingleButton
					titleButtonCadastrar="Cadastrar item"
					emptyMessage="Não há itens cadastrados."
					ComponenteCadastrar={CadastrarModal}
					toastMessage="Item cadastrado com sucesso"
					searchPlaceHolder="Pesquise por item"
					pesquisaAvancada={pesquisaAvancada}
					isPesquisaAvancada
					handlePesquisaAvancada={this.handlePesquisaAvancada}
					ordenar={this.ordenar}
					isOrderByGrid
					orderIcon={orderIcon}
					inititalOrderIcon={inititalOrderIcon}
					permission={[CENTRAL_DOACOES_PERMISSIONS.VISUALIZAR]}
					permissionCadastrar={[
						CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ITEM
					]}
				>
					<PesquisaAvancadaContext.Consumer>
						{() => (
							<PesquisaAvancadaDoacoes
								unidades={unidades}
								tiposDeItem={tiposDeItem}
								filtro={filtro}
								handlePesquisaSimplificada={
									this.handlePesquisaSimplificada
								}
								serviceSearch={values => {
									this.setState({
										pesquisaAvancada: { ...values }
									});
									this.child.current.manualSearch(
										centralDoacaoService.findAll,
										values
									);
								}}
								resetIconOrder={this.resetIconOrder}
							/>
						)}
					</PesquisaAvancadaContext.Consumer>
				</ListagemContainer>
			</React.Fragment>
		);
	}
}
